// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__rmgmc","resendInfoText":"OnGoingPaymentBox_resendInfoText__3k4Os"};